import { createBrowserRouter } from 'react-router-dom';
import { AppLayout } from './layout/AppLayout';
import { WorklistPage } from './worklist/WorklistPage';
import { StudyRoute } from './details/StudyRoute';
import { StudyDetailsPage } from './details/StudyDetailsPage';
import { UploadPage } from './upload/UploadPage';
import { WorkspacesPage } from './workspaces/WorkspacesPage';
import { CollectionsPage } from './collections/CollectionsPage';
import { CollectionDetailPage } from './collections/CollectionDetailPage';
import { ProfilePage } from './profile/ProfilePage';
import { WorkspaceActionsPage } from '../features/actions/WorkspaceActionsPage';

// The prefix this bundle was built for (Vite's `base`, e.g. '/app/'). Without
// it every route would be resolved against the origin root and a deep link
// into /app/studies/… would render nothing.
const basename = import.meta.env.BASE_URL.replace(/\/+$/, '') || '/';

export const enterpriseRouter = createBrowserRouter([
  {
    element: <AppLayout />,
    children: [
      { path: '/', element: <WorklistPage /> },
      { path: '/upload', element: <UploadPage /> },
      { path: '/workspaces', element: <WorkspacesPage /> },
      { path: '/collections', element: <CollectionsPage /> },
      { path: '/collections/:publicId', element: <CollectionDetailPage /> },
      { path: '/profile', element: <ProfilePage /> },
      { path: '/actions', element: <WorkspaceActionsPage /> },
      { path: '/studies/:studyUID', element: <StudyRoute /> },
      { path: '/studies/:studyUID/details', element: <StudyDetailsPage /> },
    ],
  },
  // No share links: enterprise has no sharing (decided 2026-09-15).
], { basename });
